
import { useEffect, useState } from 'react'
import { BoxSlider, Text } from '../..';
import TitleEvaluation from './TitleEvaluation';
import { formatNumberWithSymbol, formatNumber } from '../../../../helpers/number/numberFormat'
import api from '../../../../services/api';
import { LoadComponent } from '../../'
import { translateText } from '../../../../helpers/util';
import { useApp } from '../../../../contexts';

const CapRate = ({ officeId, period = 12, reloadTrigger, comparativeUniverse, handleVMVI }) => {
    const [load, setLoad] = useState(false)
    const { language, translations, userCountry } = useApp();
    const [capRate, setCapRate] = useState({
        vmli: 0, vmlm: 0, vmvi: 0, vmti: 0, vmtm: 0, estimatedCapRate: 0
    })

    useEffect(() => {
        loadCapRate()
    }, [reloadTrigger]);
    
    useEffect(() => {
        if(comparativeUniverse !== null){
            loadCapRate()
        }
    }, [comparativeUniverse]);

    useEffect(() => {
        loadCapRate();
    }, [period]);

    const loadCapRate = async () => {
        setLoad(true)
        let url = `/office/${officeId}/caprate?period=${period}`;
        if(comparativeUniverse !== null){
            if(comparativeUniverse.classes.length > 0){
                url+=`&buildingsClass=${comparativeUniverse.classes.join(',')}`
            }
            if(comparativeUniverse.profiles.length > 0){
                url+=`&profiles=${comparativeUniverse.profiles.join(',')}`
            }
            if(comparativeUniverse.typeRegion == "radius"){
                url+=`&radius=${comparativeUniverse.radius}`
            }
        }
        const response = await api.get(url);
        const { capRate } = response.data;
        handleVMVI(capRate.vmvi ? capRate.vmvi : capRate.vmvm)
        setCapRate(capRate)
        setLoad(false)
    }

    const handleVMLIChange = (event, newValue) => {
        const newVMLI = newValue;
        setCapRate({
            ...capRate,
            vmti: newVMLI,
            estimatedCapRate: (newVMLI / (capRate.vmvi ? capRate.vmvi : capRate.vmvm)) * 100 * 12
        })
    }

    const handleVMVIChange = (event, newValue) => {
        const newVMVI = newValue;
        handleVMVI(newVMVI)
        setCapRate({
            ...capRate,
            vmvi: newVMVI,
            estimatedCapRate: ((capRate.vmti ? capRate.vmti : capRate.vmtm) / newVMVI) * 100 * 12
        })
    }

    const valueText = (value) => {
        return formatNumberWithSymbol(Math.floor(value));
    }

    const valuePerc = (value) => {
        return `${Math.floor(value)}%`;
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: 250, height: "100%", padding: "0 0 0 5px" }}>
            <TitleEvaluation title="Cap Rate" backgroundColor='#0f2e2e' colorTitle="#FFF" />
            <LoadComponent isLoading={load}>
                <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-evenly', alignItems: 'center', width: "100%"}}>
                    <div style={{ backgroundColor: '#10587f', color: '#FFF', padding: 3, borderRadius: 8, paddingLeft: 10, paddingRight: 10 }}>{translateText("Locação", language, translations, userCountry)}</div>
                    <div style={{ backgroundColor: '#568C62', color: '#FFF', padding: 3, borderRadius: 8, paddingLeft: 10, paddingRight: 10 }}>{translateText("Venda", language, translations, userCountry)}</div>
                </div>
                <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ backgroundColor: '#0f2e2e', color: '#FFF', padding: 10, borderRadius: 12, fontSize: 36, fontWeight: 700 }}>
                        {`${formatNumber(capRate.estimatedCapRate, 1)}%`}
                    </div>
                    <Text style={{ textAlign: 'center', marginTop: 5 }}>CAP Rate {translateText("Médio Estimado", language, translations, userCountry)} (%)(12 {translateText("meses", language, translations, userCountry)})</Text>
                </div>
                <div style={{ display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
                        <div style={{ flexDirection: 'column', display: 'flex', alignItems: 'center' }}>
                            {/* <div style={{ backgroundColor: '#10587f', color: '#FFF', padding: 3, borderRadius: 8, paddingLeft: 10, paddingRight: 10 }}>Locação</div> */}
                            <BoxSlider
                                max={350}
                                // height={400}
                                onChange={handleVMLIChange}
                                styleContainer={{ margin: "2px 0" }}
                                value={capRate.vmti ? Number(capRate.vmti) : Number(capRate.vmtm)}
                                valueLabelFormat={valueText}
                            />
                        </div>
                        <div style={{ flexDirection: 'column', display: 'flex', alignItems: 'center' }}>
                            {/* <div style={{ backgroundColor: '#568C62', color: '#FFF', padding: 3, borderRadius: 8, paddingLeft: 10, paddingRight: 10 }}>Venda</div> */}
                            <BoxSlider
                                max={50000}
                                // height={400}
                                onChange={handleVMVIChange}
                                styleSlider={{ color: '#568C62' }}
                                styleContainer={{ margin: "2px 5px 2px 0" }}
                                value={Number(capRate.vmvi)}
                                valueLabelFormat={valueText}
                            />
                        </div>
                    </div>
                    <Text style={{ textAlign: 'center', marginTop: 5 }}>{translateText("Valores considerados", language, translations, userCountry)}</Text>
                    <Text style={{ textAlign: 'center' }}>{translateText("para cálculo do CAP Rate", language, translations, userCountry)}</Text>
                </div>
            </LoadComponent>
        </div>
    );
}

export default CapRate;